import React, { useContext } from "react";
import cn from "../../lib/utils/class-name";
import { SidebarMenu } from "./sideBarMenu";
import RingConnect from "../../assets/ringconnect";
import { Text } from "rizzui/typography";
import { Button } from "rizzui/button";
import { AuthContext } from "../../context/authContext";
import { useNavigate } from "react-router";
import { useModal } from "../../hooks/useModal";
import FundWallet from "../../component/fundWallet";

export default function Sidebar({ className }: { className?: string }) {
  const { profile, cardDetails, cardError: error } = useContext(AuthContext);
  const navigate = useNavigate();
  const { openModal } = useModal();
  const handleClick = () => {
    if (error) {
      navigate("/settings", {
        state: { from: "sidebar" },
      });
    } else {
      if (cardDetails?.data?.last4) {
        openModal({ view: <FundWallet /> });
      } else {
        navigate("/settings", {
          state: { from: "sidebar" },
        });
      }
    }
  };

  return (
    <aside
      className={cn(
        "fixed bottom-0 start-0 z-50 h-full !w-[278px] border-e-[.5px] border-muted bg-background 2xl:!w-[278px]",
        className
      )}
    >
      <div className="sticky top-0 z-40 px-6 pb-6 pt-5 bg-background 2xl:px-8 2xl:pt-6">
        <a href={"/"} aria-label="Site Logo">
          <RingConnect className="h-[25px] w-[190px] " />
        </a>
      </div>

      <div className="custom-scrollbar h-[calc(100%-80px)] overflow-y-auto">
        <div className="flex flex-col justify-between h-full">
          <SidebarMenu />
          <div className="w-full h-[168px] px-[16px]">
            <div className="bg-[#191919] dark:bg-[#2A2C30] rounded-[8px] h-full p-[16px] flex flex-col justify-between">
              <div>
                <Text className="font-ibmPlexSerif text-[#758599] font-[400] leading-[18.2px] text-[14px]">
                  Remaining credit
                </Text>

                <Text className="font-switzer text-[#FFFFFF] font-[500] leading-[31.68px] text-[24px]">
                  {profile?.user_currency_symbol}
                  {profile?.wallet[0]?.balance?.toFixed(2) || "0"}
                </Text>
              </div>
              <div className="w-full">
                <Text className="font-switzer text-[#758599] font-[400] leading-[15.84px] text-[12px] py-1">
                  Add credit at{" "}
                  {profile?.wallet[0]?.call_default_rate
                    ? `${profile?.user_currency_symbol}${profile?.wallet[0]?.call_default_rate}`
                    : "$0.35"}
                  /min
                </Text>
                <Button
                  variant="flat"
                  className="!bg-[#FFFFFF] dark:!bg-muted dark:!text-[#D9D9D9] font-switzer font-[400] leading-[15.84px] text-[12px] hover:text-[#2A2C30] w-full"
                  onClick={handleClick}
                >
                  Add credit
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
}
